import { Link } from "react-router-dom";
import type { Tip } from "@/types/content";

export default function HotTicker({ list }: { list: Tip[] }) {
  const items = [...list, ...list];

  return (
    <section aria-label="实时热点滚动" className="border-b border-background-200 bg-background-50">
      <div className="mx-auto flex w-full items-center gap-4 px-4 py-3 md:px-8">
        <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 font-label text-xs font-medium text-background-50">
          <i className="ri-fire-fill" aria-hidden="true" />
          实时热点
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track flex w-max items-center gap-8">
            {items.map((tip, index) => (
              <Link
                key={`${tip.id}-${index}`}
                to={`/detail/${tip.id}`}
                className="whitespace-nowrap font-label text-sm text-foreground-700 transition-colors hover:text-primary-700"
              >
                <span className="mr-2 text-accent-600">·</span>
                {tip.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}